import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import "./styles/Common.scss";
import "./styles/Responsive.scss";
import AppRoutes from "./routes/index";
import "bootstrap/dist/css/bootstrap.min.css";
import AntdConfigProvider from "../src/services/AntdConfigProvider";
import { socket } from "./socket";

import { Provider } from "react-redux";
import store from "./store";

function App() {
  useEffect(() => {
    socket.on("connect", () => {
      // USER IS ONLINE
      console.log("connected==>");
    });
  }, []);
  return (
    <BrowserRouter>
      <AntdConfigProvider>
        <Provider store={store}>
          <AppRoutes />
        </Provider>
      </AntdConfigProvider>
    </BrowserRouter>
  );
}

export default App;
